import moment from 'moment';

const dateTimeFormats = [
  moment.ISO_8601,
  'YYYY-MM-DD HH:mm:ss.SSSSSSSSS Z',
  'YYYY-MM-DD HH:mm:ss.SSSSSS Z',
  'YYYY-MM-DD HH:mm:ss.SSS Z',
  'YYYY-MM-DD HH:mm:ss Z',
  'YYYY-MM-DD HH:mm:ss.SSSSSSSSS',
  'YYYY-MM-DD HH:mm:ss.SSSSSS',
  'YYYY-MM-DD HH:mm:ss.SSS',
  'YYYY-MM-DD HH:mm:ss',
  'DD/MM/YYYY HH:mm',
  'DD/MM/YYYY hh:mm',
  'DD/MM/YYYY HH:mm:ss',
  'DD/MM/YYYY HH:mm A',
  'DD/MM/YYYY hh:mm A',
  'DD/MM/YYYY h:mm A',
  'DD-MM-YYYY hh:mm a'
];

export const cleanGoDate = (dateStr) => {
  if (!dateStr) return dateStr;
  let cleaned = String(dateStr).split(' m=')[0];
  cleaned = cleaned.replace(/\s+[A-Z]{2,4}(?=\s|$)/g, '');
  cleaned = cleaned.replace(/(\s[+-]\d{2}(?::?\d{2}))\s+[+-]\d{2}(?::?\d{2})?(?=\s|$)/g, '$1');
  cleaned = cleaned.replace(/\s([+-]\d{2})$/, (_, offset) => ` ${offset}00`);
  return cleaned.trim();
};

export const parseDateTime = inputDateTime => {
  if (
    moment.isMoment(inputDateTime) ||
    inputDateTime instanceof Date ||
    typeof inputDateTime === 'number'
  ) {
    return moment(inputDateTime);
  }

  const cleanedDate = cleanGoDate(inputDateTime);
  return moment(cleanedDate, dateTimeFormats, true);
};

export function formatDateTime(inputDateTime) {
  const date = parseDateTime(inputDateTime);
  return date.isValid() ? date.format('DD MMM YYYY[\n]hh:mm A') : '-';
}

export function formatDateTimeWithComma(inputDateTime) {
  const date = parseDateTime(inputDateTime);
  return date.isValid() ? date.format('DD MMM YYYY hh:mm A').replace(/ /g, '\u00A0') : '-';
}

export function formatDateTimeAs(inputDateTime, outputFormat, fallback = '-') {
  const date = parseDateTime(inputDateTime);
  return date.isValid() ? date.format(outputFormat) : fallback;
}

export function formatDate(inputDate) {
  if (!inputDate) return '-';
  const cleanedDate = cleanGoDate(inputDate);
  const date = moment(cleanedDate, ['YYYY-MM-DD', 'DD/MM/YYYY'], true);
  return date.isValid() ? date.format('DD MMM YYYY') : '-';
}
export function formatDateYear(inputDate) {
  const date = moment(cleanGoDate(inputDate), ['YYYY-MM-DD', 'DD/MM/YYYY'], true);
  return date.isValid() ? date.format('YYYY-MM-DD') : '';
}

export function formatTime(inputTime) {
  return moment(inputTime).format('h:mm A');
}
export const formatInputTime = isoString => {
  if (!isoString) return null;
  return new Date(isoString);
};

export const formatSendTime = dateString => {
  if (!dateString) return '0000-01-01T00:00:00Z';

  let date = new Date(dateString);
  let timePart = date.toISOString().substring(11, 19);
  return `0000-01-01T${timePart}Z`;
};

// Input 14/02/2025 12:36 pm
export const formatConvertedDateTime = inputDateTime => {
  return moment(inputDateTime, 'DD-MM-YYYY hh:mm a').format('DD MMM YYYY[\n]hh:mm A');
};

export const getDateMinusThreeMonths = () => {
  return moment().subtract(3, 'months').toDate();
};

export const convertTimeToDate = (timeStr, baseDate = new Date()) => {
  const base = moment(baseDate);
  const time = moment(timeStr, 'HH:mm');

  return base
    .set({
      hour: time.hour(),
      minute: time.minute(),
      second: 0,
      millisecond: 0
    })
    .toDate();
};
